import { cn } from "@/lib/utils";
import { CompanyInfo } from "./types";
import { HeroFeaturedContent } from "./HeroFeaturedContent";

interface HeroContentProps {
  companyInfo: CompanyInfo | null;
  isScrolled: boolean;
  onBookNow: () => void;
}

export const HeroContent = ({ companyInfo, isScrolled, onBookNow }: HeroContentProps) => {
  return (
    <>
      {/* Main Hero Content - Company Info - Upper portion */}
      <div className="absolute inset-0 flex flex-col items-center justify-start pt-20 text-white">
        {companyInfo?.logo_url && (
          <div className={cn(
            "mb-6 transition-all duration-700 transform",
            isScrolled ? "opacity-0 scale-50" : "opacity-100 scale-100 animate-float"
          )}>
            <div className="w-48 h-48 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-md shadow-2xl border border-shell-primary/20">
              <div className="w-36 h-36 bg-gradient-to-b from-shell-light to-white rounded-full flex items-center justify-center p-6">
                <img 
                  src={companyInfo.logo_url} 
                  alt={companyInfo.name}
                  className="w-full h-full object-contain drop-shadow-xl"
                  style={{ filter: 'brightness(0.95) contrast(1.1)' }}
                />
              </div>
            </div>
          </div>
        )}
        <div className={cn(
          "text-center transition-all duration-700 transform",
          isScrolled ? "opacity-0 translate-y-10" : "opacity-100 translate-y-0"
        )}>
          <h1 
            className="text-4xl md:text-6xl font-bold mb-4 animate-fade-up 
              drop-shadow-[0_4px_8px_rgba(0,0,0,0.3)] 
              text-shell-light hover:text-white 
              transition-all duration-500 transform hover:scale-105"
          >
            {companyInfo?.name || "Shell & Sands"}
          </h1>
          <p 
            className="text-lg md:text-2xl mb-6 
              animate-fade-up delay-100 
              drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)] 
              text-shell-secondary hover:text-white
              transition-all duration-500 transform hover:scale-102"
          >
            {companyInfo?.slogan || "Discover Paradise Your Way"}
          </p>
        </div>
      </div>
      
      {/* Featured Content Section - Lower portion */}
      <HeroFeaturedContent isScrolled={isScrolled} onBookNow={onBookNow} />
    </>
  );
};